import React, { Fragment } from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import Button from '../../atoms/button';
import { SECONDARY_COLOR } from '../../color-constants';
import MsxIcons from '../../features/msx-icons';
import ProductLink from '../product_link';
import ComparatorValueHintMobile from './comparator_value_hint_mobile';

const Container = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: 800px) {
    display: flex;
  }
`;

const StickyHeader = styled.div`
  position: absolute;
  z-index: 4;
  top: 20px;
  left: 10px;
  right: 10px;
  overflow: hidden;
  pointer-events: none;
`;

const OverflowWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 20px 10px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
  user-select: none;
  cursor: grab;

  ${props => props.$isMouseDown ? `cursor: grabbing;` : ''}
`;

const ComparatorWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  overflow: hidden;
`;

const ComparatorTable = styled.table`
  min-width: 100%;
  max-width: 100%;
`;

const ComparatorHeader = styled.thead``;

const ComparatorBody = styled.tbody``;

const ComparatorTableHeaderRow = styled.tr`
  th:first-child {
    position: absolute;
    z-index: 1;
  }
`;

const ComparatorHeaderCell = styled.th`
  ${props => props.width ? `
    min-width: ${props.width};
    width: ${props.width};
    max-width: ${props.width};
  ` : ''}
`;

const ComparatorTableRow = styled.tr`
  background-color: white;
  td:first-child {
    position: absolute;
    z-index: 3;
  }
  ${props => props.$hideRow ? `visibility: hidden;` : ''}
  ${props => props.$resetPointerEvents ? `pointer-events: auto;` : ''}
`;

const ComparatorItemRow = styled.tr`
  border-bottom: 1px solid #D9D9D9;
  td:first-child {
    pointer-events: none;
    position: absolute;
    z-index: 1;
    left: 10px;
    ${props => props.width ? `
    min-width: ${props.width};
    width: ${props.width};
    max-width: ${props.width};
  ` : ''}
  }
  ${props => props.$hideRow ? `visibility: hidden; border-bottom: 0px;`: ''}
  ${props => props.$resetPointerEvents ? `pointer-events: auto;` : ''}
`;

const ComparatorTableCell = styled.td`
  vertical-align: middle;
`;

const ComparatorTableValueCell = styled(ComparatorTableCell)`
`;

const ComparatorGroupTitleCell = styled(ComparatorTableCell)`
  white-space: nowrap;
`;

const ComparatorGroupTitleCellContent = styled.div`
  padding: 10px 0px;
  ${props => props.$hide ? 'visibility: hidden;' : ''}
`;

const ComparatorTableCellContent = styled.div`
  padding: 10px;
  ${props => props.$hide ? 'visibility: hidden;' : ''}
`;

const CenteredComparatorTableCellContent = styled(ComparatorTableCellContent)`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-wrap;
  text-align: center;
  qds-button {
    position: relative;
    z-index: 2;
    --qds-internal-white-space-property: pre-wrap;
  }
`;

const ComparatorItemValueTableCellContent = styled(CenteredComparatorTableCellContent)`
`;

const VisibleComparatorItemValueTableCellContent = styled(ComparatorItemValueTableCellContent)`
  flex-direction: column;
`;


const PreferredChip = styled.span`
  font-size: 14px;
  font-weight: 400;
  background-color: #CCF1FF;
  color: #005B80;
  padding: 5px 10px;
  border-radius: 9999px;
`;

const ComparatorTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
`;

const ComparatorValueGroupTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  white-space: pre-wrap;
`;

const ComparatorItemLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

const ComparatorIconWrapper = styled.div`
  min-width: 32px;
  width: 32px;
  max-width: 32px;
  min-height: 32px;
  height: 32px;
  max-height: 32px;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
`;

const ItemValueWrapper = styled.div`
  display: flex;
  > div {
    display: flex;
    align-items: center;
    min-width: 50%;
    width: 50%;
    max-width: 50%;
    box-sizing: border-box;
    background-color: white;
  }
`;

const HiddenValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  width: 100%;
  max-width: 100%;
`;

const NavigationChipsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const NavigationChipItem = styled.div`
  margin-top: 10px;
  background-color: #D9D9D9;
  min-height: 8px;
  height: 8px;
  max-height: 8px;
  min-width: 8px;
  width: 8px;
  max-width: 8px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.$selected ?  `
    background-color: #0F0F0F;
    min-width: 16px;
    width: 16px;
    max-width: 16px;
  ` : ''}

  :not(:last-of-type) {
    margin-right: 10px;
  }
`;

const COMPARATOR_VALUE_TYPES = {
  TEXT: 'text',
  ICON: 'icon',
  NUMERIC: 'numeric'
};

const VALUE_ICON_MAPPING = {
  CHECK: 'check'
};

let componentId = 0;

class MobileLicenseComparatorTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      wrapperWidth: 0,
      isMouseDown: false,
      visibleTypeIdx: 0,
      componentId: componentId++
    };
    this._isMounted = false;
    this._performScroll = false;

    this.mouseCoords = {
      startX: 0,
      scrollLeft: 0,
   };
  }

  handleVerticalScroll () {
    const headerDemarcation = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-sticky-header-demarcation-mobile`);
    const positionerElement = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute-mobile`);
    if (positionerElement) {
      if (this._verticalScrollDiv && this._wrapperRef && this._verticalScrollDiv.scrollTop > (this._wrapperRef.offsetTop + 20)) {
        let newTopPosition = this._verticalScrollDiv.scrollTop - this._wrapperRef.offsetTop;
          if (headerDemarcation) {
            const positionerBounding = positionerElement.getBoundingClientRect();
            newTopPosition = (Math.min(newTopPosition, (positionerBounding.height - 20) - headerDemarcation.offsetTop));
          }
          positionerElement.style.top = `${newTopPosition}px`;
      } else {
        positionerElement.style.top = '20px';
      }
    }
  }

  handleHorizontalScroll () {
    const positionerElement = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute-mobile`);
    if (positionerElement) {
      positionerElement.style.left = `${(-this._scrollableRef.scrollLeft) + 10}px`;
    }
  }

  updateWindowSize = () => {
    if (this._wrapperRef) {
      const wrapperRect = this._wrapperRef.getBoundingClientRect();
      const scrollableRef = this._scrollableRef;

      // Get rid of the padding
      const correctedWidth = (wrapperRect.width - 20);
      if (correctedWidth !== this.state.wrapperWidth) {
        this.updateStateIfMounted({wrapperWidth: correctedWidth});
      }

      const tabWidth = Math.floor(correctedWidth);
      scrollableRef.scrollTo({
        left: tabWidth * (Math.round(scrollableRef.scrollLeft / tabWidth)),
        behavior: "smooth",
      });
    }
  }

  componentDidMount = () => {
    this._isMounted = true;
    this._verticalScrollDiv = document.getElementById('slc-license-groups-scrollable-wrapper');

    this._widthChecker = setInterval(() => {
      if (this._wrapperRef) {
        const shouldPerformScroll = this._performScroll;
        this._performScroll = false;
        const wrapperRect = this._wrapperRef.getBoundingClientRect();
        const scrollableRef = this._scrollableRef;

        // Get rid of the padding
        const correctedWidth = Math.floor((wrapperRect.width - 20));
        if (correctedWidth !== this.state.wrapperWidth) {
          this.updateStateIfMounted({wrapperWidth: correctedWidth});
        }

        let proximity = 0;
        let minimalDistance = Number.MAX_VALUE;

        for (let i = 0; i < this.props.licenseSubGroup.comparatorTypes.length; i++) {
          const distance = Math.abs(scrollableRef.scrollLeft - (correctedWidth * i));
          if (distance < minimalDistance) {
            proximity = i;
            minimalDistance = distance;
          }
        }

        if (proximity !== this.state.visibleTypeIdx) {
          this.updateStateIfMounted({
            visibleTypeIdx: proximity
          });
        }

        if (shouldPerformScroll) {
          scrollableRef.scrollTo({
            left: correctedWidth * proximity,
            behavior: "smooth",
          });
        }

      }
    }, 100);

    window.addEventListener("resize", this.updateWindowSize);

    if (this._verticalScrollDiv && this._scrollableRef) {
      this._verticalScrollFunction = () => {
        this.handleVerticalScroll();
      };

      this._horizontalScrollFunction = () => {
        this.handleHorizontalScroll();
      };

      this._screenResizeFunction = () => {
        this.handleVerticalScroll();
        this.handleHorizontalScroll();
      }

      this._verticalScrollDiv.addEventListener("scroll", this._verticalScrollFunction);
      this._scrollableRef.addEventListener("scroll", this._horizontalScrollFunction);
      window.addEventListener("resize", this._screenResizeFunction);
    }

  }

  componentWillUnmount = () => {
    if (this._widthChecker) {
      clearInterval(this._widthChecker);
    }
    window.removeEventListener("resize", this.updateWindowSize);

    if (this._verticalScrollDiv) {
      this._verticalScrollDiv.removeEventListener("scroll", this._verticalScrollFunction)
    }
    if (this._scrollableRef) {
      this._scrollableRef.removeEventListener("scroll", this._horizontalScrollFunction);
    }
    window.removeEventListener("resize", this._screenResizeFunction);

    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  renderComparatorPreferredRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            {comparatorType.preferred && <CenteredComparatorTableCellContent>
              <PreferredChip>{I10n.get('screen.licence_selector.preferred')}</PreferredChip>
            </CenteredComparatorTableCellContent>}
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderComparatorTitleRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            <CenteredComparatorTableCellContent>
              <ComparatorTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_type.name.${comparatorType.labelKey}`, comparatorType.comparatorTypeName)}</ComparatorTitle>
            </CenteredComparatorTableCellContent>
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );

  }

  renderComparatorConfigureButtonRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType) => {
          return (<ComparatorTableCell key={comparatorType.comparatorTypeKey}>
            <CenteredComparatorTableCellContent>
              {comparatorType.licenseTypesKey && <Button importance="emphasized" size="standard" disabled={this.props.isSaving} onClick={() => {
                this.props.onAddSoftwareLicencesRequested(comparatorType);
              }}>
                {I10n.getOrDefault(`screen.licence_selector.configure_and_buy.${this.props.softwareSelection}`, I10n.get('screen.licence_selector.configure_and_buy'))}
              </Button>}
            </CenteredComparatorTableCellContent>
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderComparatorKnowMoreRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            {this.props.knowMoreLinksMap[comparatorType.scopedKnowMoreReferences[0].id] && <CenteredComparatorTableCellContent>
              <ProductLink fullLink={this.props.knowMoreLinksMap[comparatorType.scopedKnowMoreReferences[0].id]} label={I10n.get('screen.licence_selector.know_more')}></ProductLink>
            </CenteredComparatorTableCellContent>}
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderValueIcon(value) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [VALUE_ICON_MAPPING.CHECK]: () => {
        return <ComparatorIconWrapper>
          <MsxIcons name="done-stroke" size="medium"></MsxIcons>
        </ComparatorIconWrapper>;
      }
    }

    if (mapTypeToRenderFunction[value]) {
      renderFunction = mapTypeToRenderFunction[value];
    }

    return renderFunction();
  }

  renderComparatorItemValue(comparatorItem) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [COMPARATOR_VALUE_TYPES.TEXT]: () => {
        return <ComparatorItemLabel>{I10n.getOrDefault(`screen.licence_selector.comparator_value.name.${comparatorItem.labelKey}`, comparatorItem.value)}</ComparatorItemLabel>;
      },
      [COMPARATOR_VALUE_TYPES.ICON]: () => {
        return this.renderValueIcon(comparatorItem.value);
      },
      [COMPARATOR_VALUE_TYPES.NUMERIC]: () => {
        return <ComparatorItemLabel>{comparatorItem.value}</ComparatorItemLabel>;
      }
    }

    if (mapTypeToRenderFunction[comparatorItem?.type]) {
      renderFunction = mapTypeToRenderFunction[comparatorItem.type];
    }

    return renderFunction();
  }

  renderComparatorValueGroup(comparatorValueGroup, comparatorTypes, hideRow) {
    return (
      <>
        <ComparatorTableRow $hideRow={hideRow}>
          <ComparatorGroupTitleCell>
            <ComparatorGroupTitleCellContent>
              <ComparatorValueGroupTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_group.name.${comparatorValueGroup.labelKey}`, comparatorValueGroup.comparatorGroupName)}</ComparatorValueGroupTitle>
            </ComparatorGroupTitleCellContent>
          </ComparatorGroupTitleCell>
          {comparatorTypes.map((comparatorType, idx) => {
            return (
              <ComparatorGroupTitleCell key={idx}>
                <ComparatorGroupTitleCellContent $hide={true}>
                  <ComparatorValueGroupTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_group.name.${comparatorValueGroup.labelKey}`, comparatorValueGroup.comparatorGroupName)}</ComparatorValueGroupTitle>
                </ComparatorGroupTitleCellContent>
              </ComparatorGroupTitleCell>
            );
          })}
        </ComparatorTableRow>
        {comparatorValueGroup.comparatorItems.map((comparatorItem, idx) => {
          const comparatorName = I10n.getOrDefault(`screen.licence_selector.comparator_item.name.${comparatorItem.labelKey}`, comparatorItem.comparatorItemName)
          return (
            <ComparatorItemRow key={idx} width={`${this.state.wrapperWidth}px`} $hideRow={hideRow}>
              <ComparatorTableValueCell>
                <ItemValueWrapper>
                  <ComparatorTableCellContent>
                    <ComparatorItemLabel>
                      {comparatorName}
                    </ComparatorItemLabel>
                  </ComparatorTableCellContent>
                  <ComparatorItemValueTableCellContent $hide={true}>
                    {comparatorTypes.map((comparatorType, idx) => {
                      const comparatorValue = comparatorType?.comparatorValues?.[comparatorItem.comparatorItemKey];
                      return (<HiddenValueWrapper key={idx}>
                        {this.renderComparatorItemValue(comparatorValue)}
                        {comparatorValue?.hint &&
                          <ComparatorValueHintMobile
                            comparatorValue={comparatorValue}
                          />
                        }
                      </HiddenValueWrapper>);
                    })}
                  </ComparatorItemValueTableCellContent>
                </ItemValueWrapper>
              </ComparatorTableValueCell>
              {comparatorTypes.map((comparatorType, idx) => {
                const comparatorValue = comparatorType?.comparatorValues?.[comparatorItem.comparatorItemKey];
                return (
                  <ComparatorTableValueCell key={idx}>
                    <ItemValueWrapper>
                      <ComparatorTableCellContent $hide={true}>
                        <ComparatorItemLabel>
                          {comparatorName}
                        </ComparatorItemLabel>
                      </ComparatorTableCellContent>
                      <VisibleComparatorItemValueTableCellContent>
                        {this.renderComparatorItemValue(comparatorValue)}
                        {comparatorValue?.hint &&
                          <ComparatorValueHintMobile
                            comparatorValue={comparatorValue}
                          />
                        }
                      </VisibleComparatorItemValueTableCellContent>
                    </ItemValueWrapper>
                  </ComparatorTableValueCell>
                );
              })}
            </ComparatorItemRow>
          );
        })}
      </>
    );
  }

  handleDragStart = (e) => {
    const slider = this._scrollableRef;
    const startX = e.pageX - slider.offsetLeft;
    const scrollLeft = slider.scrollLeft;
    this.mouseCoords = { startX, scrollLeft };
    this.updateStateIfMounted({isMouseDown: true});
  }

  handleTouchDragStart = (e) => {
    const slider = this._scrollableRef;
    const startX = e.touches[0].pageX - slider.offsetLeft;
    const scrollLeft = slider.scrollLeft;
    this.mouseCoords = { startX,scrollLeft };
    this.updateStateIfMounted({isMouseDown: true});
  }

  handleDragEnd = () => {
    if (this.state.isMouseDown) {
      this.updateStateIfMounted({isMouseDown: false});
      this._performScroll = true;
    }
  }

  handleDrag = (e) => {
    if (!this.state.isMouseDown) return;
    const slider = this._scrollableRef;
    const x = e.pageX - slider.offsetLeft;
    const walkX = (x - this.mouseCoords.startX) * 1.5;
    slider.scrollLeft = this.mouseCoords.scrollLeft - walkX;
  }

  handleTouchDrag = (e) => {
    if (!this.state.isMouseDown) return;
    const slider = this._scrollableRef;
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walkX = (x - this.mouseCoords.startX) * 1.5;
    slider.scrollLeft = this.mouseCoords.scrollLeft - walkX;
  }

  renderComparatorTable (licenseSubGroup, headerElements, hideBody) {
    return (
      <ComparatorTable>
        <ComparatorHeader>
          <ComparatorTableHeaderRow>
            {headerElements.map((elt, idx) => {
              return (
                <Fragment key={idx}>
                  {elt}
                </Fragment>
              );
            })}
          </ComparatorTableHeaderRow>
        </ComparatorHeader>
        <ComparatorBody>
          {this.renderComparatorPreferredRow(licenseSubGroup)}
          {this.renderComparatorTitleRow(licenseSubGroup)}
          {this.renderComparatorConfigureButtonRow(licenseSubGroup)}
          {this.renderComparatorKnowMoreRow(licenseSubGroup)}
          {hideBody && <tr id={`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-sticky-header-demarcation-mobile`}></tr>}
          {licenseSubGroup.comparatorGroups.map((comparatorValueGroup, idx) => {
            return (
              <Fragment key={idx}>
                {this.renderComparatorValueGroup(comparatorValueGroup, licenseSubGroup.comparatorTypes, hideBody)}
              </Fragment>
            );
          })}

        </ComparatorBody>
      </ComparatorTable>
    );
  }

  render() {
    const {
      licenseSubGroup
    } = this.props;

    const id = `${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute-mobile`;
    const headerElements = [<ComparatorHeaderCell width={`${this.state.wrapperWidth}px`}></ComparatorHeaderCell>];
    licenseSubGroup.comparatorTypes.forEach(() => {
      headerElements.push(<ComparatorHeaderCell width={`${this.state.wrapperWidth}px`}></ComparatorHeaderCell>);
    });

    return (
    <Container>
      <OverflowWrapper
        onMouseDown={this.handleDragStart}
        onMouseLeave={this.handleDragEnd}
        onMouseUp={this.handleDragEnd}
        onMouseMove={this.handleDrag}
        onTouchStart={this.handleTouchDragStart}
        onTouchMove={this.handleTouchDrag}
        onTouchEnd={this.handleDragEnd}
        ref={wrapperRef => { this._wrapperRef = wrapperRef }}
        $isMouseDown={this.state.isMouseDown}
      >
        <StickyHeader id={id}>
          {this.renderComparatorTable(licenseSubGroup, headerElements, true)}
        </StickyHeader>
        <ComparatorWrapper  ref={scrollableRef => { this._scrollableRef = scrollableRef }}>
          {this.renderComparatorTable(licenseSubGroup, headerElements, false)}
        </ComparatorWrapper>

      </OverflowWrapper>
      <NavigationChipsWrapper>
        {licenseSubGroup.comparatorTypes.map((type, idx) => {
          return (
            <NavigationChipItem key={idx} $selected={idx === this.state.visibleTypeIdx} onClick={() => {
              const scrollableRef = this._scrollableRef;
              if (scrollableRef) {
                scrollableRef.scrollTo({
                  left: this.state.wrapperWidth * idx,
                  behavior: "smooth",
                });
              }
            }}></NavigationChipItem>
          );
        })}
      </NavigationChipsWrapper>

    </Container>);
  }
}

export default MobileLicenseComparatorTable;
